import { useState } from 'react';
import BugReportModal from './BugReportModal';
import { SupportIcon } from '../assets/moduleIcons';
import './BugReports.css';

// Global floating action button, shown on every authenticated page. Opens a
// small menu: file a report, or jump to the Bug Tracker.
const BugReportButton = ({ user, currentPage = 'Dashboard', onOpenTracker }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="bug-fab-wrap">
        {menuOpen && (
          <>
            <div className="bug-fab-backdrop" onClick={() => setMenuOpen(false)} />
            <div className="bug-fab-menu" role="menu">
              <button className="bug-fab-menu-item" onClick={() => { setMenuOpen(false); setShowModal(true); }}>
                <span className="bug-fab-menu-icon">🐞</span> Report a bug / feature
              </button>
              <button className="bug-fab-menu-item" onClick={() => { setMenuOpen(false); if (onOpenTracker) onOpenTracker(); }}>
                <span className="bug-fab-menu-icon"><img src={SupportIcon} alt="" style={{ width: '1.1rem', height: '1.1rem', filter: 'brightness(0)', verticalAlign: '-2px' }} /></span> Support
              </button>
            </div>
          </>
        )}
        <button
          className={`bug-fab ${menuOpen ? 'active' : ''}`}
          title="Support"
          aria-label="Support"
          onClick={() => setMenuOpen(o => !o)}
        >
          <img src={SupportIcon} alt="" style={{ width: '30px', height: '30px', display: 'block' }} />
        </button>
      </div>

      {showModal && (
        <BugReportModal
          user={user}
          currentPage={currentPage}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default BugReportButton;
